module.exports = __webpack_public_path__ + "static/media/settings.87d34b3b.svg";